import { useCallback, useState } from 'react';
import Loader from '../../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { CompanyModel } from '../../../../models/Company';
import ChangePassword from './ChangePassword';
import CompanyData from './CompanyData';

interface ICompanyCardProps {
  company: CompanyModel;
}

export default function CompanyCard(props: Readonly<ICompanyCardProps>) {
  const [company, setCompany] = useState<CompanyModel>(props.company);

  const companyStateWrapper = useCallback(
    (company: CompanyModel) => {
      setCompany(company);
    },
    [setCompany],
  );
  return (
    <div className="panel padding-xl company-settings-section">
      <Loader loading={!company} loader={<LoadingSpinner />}>
        <CompanyData
          name={company.name}
          recom={company.recom}
          cui={company.cui}
          iban={company.iban}
        />
        <ChangePassword
          company={company}
          parentStateSetter={companyStateWrapper}
        />
      </Loader>
    </div>
  );
}
